import { useEffect, useState } from 'react';
import '../styles/theme.scss';
import { App as AppPropulsion } from '@ui-propulsion/react-components';
import { DiamondApp } from '@diamond-design/components';
import Head from 'next/head';
import http from 'lc-http';
import Header from '../components/header/header';
import Footer from '../components/footer/footer';
import PfFooter from '../components/footer/pfFooter/pfFooter';
import Disclaimer from '../components/disclaimer/disclaimer';
import LCHead from '../components/lcHead/lcHead';
import PartnerHeader from '../components/partnerHeader/partnerHeader';
import CustHelpChat from '../components/custHelpChat/custHelpChat';
import XrayMode from '../components/xrayMode/xrayMode';
import Custom404 from '../components/custom-404/custom-404';
import setCookiesForPartnerPages from '../services/helpers/setCookiesForPartnerPages';
import { AppContext } from '../context';
import TrustedBadgeFooter from '../components/footer/trustedBadgeFooter/trustedBadgeFooter';
import mulishFont from '../fonts/fonts';
import '../styles/globals.scss';

function MyApp({ Component, pageProps }) {
  const [loginCookie, setLoginCookie] = useState(false);
  useEffect(() => {
    http
      .get('/api/get-login-cookie-status')
      .then((response) => {
        const { data } = response;
        setLoginCookie(data.status ?? false);
      })
      .catch(() => {
        setLoginCookie(false);
      });
  }, []);

  useEffect(() => {
    setCookiesForPartnerPages();
  });

  const getFooterComponent = () => {
    switch (pageProps?.footer?.type) {
      case 'Patient Solutions':
        return <PfFooter {...pageProps.footer} />;
      case 'Trusted Badge':
        return <TrustedBadgeFooter {...pageProps.footer} />;
      default:
        return <Footer {...pageProps.footer} />;
    }
  };
  return (
    <>
      {pageProps.seo && <LCHead {...pageProps.seo} />}
      {pageProps.csrfToken && (
        <Head>
          <meta name="csrf-header" content="csrf" />
          <meta name="csrf-token" content={pageProps.csrfToken} />
          <style global>{`
            :root {
              --font-mulish: ${mulishFont.style.fontFamily};
            }
          `}</style>
        </Head>
      )}
      <AppContext.Provider value={loginCookie}>
        <DiamondApp>
          <AppPropulsion>
            {pageProps.header &&
              (pageProps.header.type === 'partnerHeader' ? (
                <PartnerHeader {...pageProps.header} />
              ) : (
                <Header {...pageProps.header} />
              ))}
            {pageProps.notFound ? (
              <Custom404 />
            ) : (
              <main className={mulishFont.className}>
                <Component {...pageProps} />
              </main>
            )}
            {pageProps.footer && getFooterComponent()}
            {pageProps.preview && pageProps.spaceId && pageProps.disclaimer && (
              <XrayMode
                title="disclaimer"
                spaceId={pageProps.spaceId}
                entryId={pageProps.entryId}
              />
            )}
            {pageProps.disclaimer && <Disclaimer {...pageProps.disclaimer} />}
            {pageProps.tags && pageProps.tags.includes('bankPage') && (
              <CustHelpChat />
            )}
          </AppPropulsion>
        </DiamondApp>
      </AppContext.Provider>
    </>
  );
}

export default MyApp;
